export const filePath = "https://assets.answerforce.com/answerforce/us/website";
